"use strict";
var $dyn;
(function ($dyn) {
    var serverForm;
    (function (serverForm) {
        serverForm.serializers = {};
        $dyn.serverForm.serializers.json = $dyn.serverForm.serializers[$dyn.serverForm.ValueType.serialized] = {
            deserialize: function (propertyDescriptorValue) {
                return propertyDescriptorValue !== undefined && propertyDescriptorValue !== "" ? JSON.parse(propertyDescriptorValue) : undefined;
            },
        };
        $dyn.serverForm.serializers.plain = $dyn.serverForm.serializers[$dyn.serverForm.ValueType.string] = {
            deserialize: function (propertyDescriptorValue) {
                return propertyDescriptorValue;
            },
        };
        $dyn.serverForm.serializers[$dyn.serverForm.ValueType.collection] = {
            deserialize: function (propertyDescriptorValue) {
                var deserializedProperties = new Array();
                if (propertyDescriptorValue) {
                    var values = propertyDescriptorValue.$values;
                    for (var i = 0, len = values.length; i < len; i++) {
                        deserializedProperties.push(JSON.parse(values[i]));
                    }
                }
                return deserializedProperties;
            },
        };
        $dyn.serverForm.serializers.default = $dyn.serverForm.serializers[$dyn.serverForm.ValueType.object] = {
            deserialize: function (propertyDescriptorValue, controlParams, rootControlParams) {
                if (propertyDescriptorValue) {
                    var value_1;
                    if (propertyDescriptorValue && propertyDescriptorValue.$type && propertyDescriptorValue.$values) {
                        propertyDescriptorValue = propertyDescriptorValue.$values;
                        value_1 = $dyn.serverForm.serializers.default.deserialize(propertyDescriptorValue, controlParams, rootControlParams);
                    }
                    else {
                        value_1 = propertyDescriptorValue;
                    }
                    return value_1;
                }
            },
        };
        $dyn.serverForm.serializers.InteractionCommand = {
            deserialize: function (command, controlParams) {
                return $dyn.bindingFunctions.$command(controlParams, command);
            },
        };
        $dyn.serverForm.serializers.Navigate = {
            deserialize: function (command, controlParams) {
                var serverCommand = $dyn.bindingFunctions.$command(controlParams, command);
                return function (parameters, callback) {
                    var interactionHandler = $dyn.serverForm.interactionHandler;
                    // If the view model does not have a FormName property we just execute the base command
                    var formName;
                    if (controlParams && controlParams._element) {
                        var control = $dyn.controlOptions(controlParams._element);
                        if (control) {
                            formName = $dyn.value(control.FormName);
                        }
                    }
                    if (!formName || !$dyn.serverForm.compilation.StaticLoader.staticLoaderOn) {
                        serverCommand([]);
                    }
                    else {
                        var options_1 = { name: formName };
                        var rootElement_1 = $dyn.shell.createForm(options_1);
                        var formId_1 = rootElement_1.getAttribute("data-dyn-formid");
                        interactionHandler.blockInbound(true);
                        rootElement_1.dynPerformance.requestStart = window.performance.now();
                        var wrappedCallback = function () {
                            // Clean up the preloaded form if it was not completed.
                            var preloadedForm = $dyn.serverForm.interactionHandler.getFormElement(formId_1);
                            if (preloadedForm && $dyn.value(preloadedForm.dynReadyState) === $dyn.ui.ReadyState.request) {
                                preloadedForm.dynReadyState($dyn.ui.ReadyState.aborted);
                                $dyn.shell._removeForm(preloadedForm);
                            }
                            $dyn.callFunction(callback, this, arguments);
                        };
                        serverCommand([formId_1], wrappedCallback);
                        // Handler will be unblocked as a part of the load function, once static loading is done.
                        $dyn.serverForm.compilation.StaticLoader.load(formName, rootElement_1, formId_1, interactionHandler);
                    }
                };
            },
        };
        $dyn.serverForm.serializers.OpenPopup = {
            deserialize: function (command, controlParams) {
                var serverCommand = $dyn.bindingFunctions.$command(controlParams, command);
                return function (parameters, callback) {
                    // SEE COMMENT ABOVE
                    // THIS WILL BE PART OF INTERACTION HANDLER LOGIC
                    var formName;
                    if (controlParams) {
                        formName = $dyn.value(controlParams.FormName);
                    }
                    if (formName && $dyn.serverForm.compilation.StaticLoader.staticLoaderOn) {
                        var popupId = null;
                        var control = $dyn.controlOptions(controlParams._element);
                        if (control) {
                            popupId = $dyn.value(control.PopupId);
                        }
                        // Ideally the popup parameters should have the popup element.
                        var rootElement_2 = document.getElementById("form_" + popupId);
                        if (popupId) {
                            var interactionHandler_1 = $dyn.serverForm.interactionHandler;
                            interactionHandler_1.blockInbound(true);
                            rootElement_2.dynPerformance.requestStart = window.performance.now();
                            serverCommand([popupId], callback);
                            // Channel will be unblocked as a part of the load function, once static loading is done.
                            $dyn.serverForm.compilation.StaticLoader.load(formName, rootElement_2, popupId, interactionHandler_1);
                        }
                    }
                    else {
                        serverCommand([], callback);
                    }
                };
            },
        };
        $dyn.serverForm.serializers.InitPartForm = {
            deserialize: function (command, controlParams) {
                var serverCommand = $dyn.bindingFunctions.$command(controlParams, command);
                return function preLoadPartForm(element) {
                    // some items like TaskPane, Help, App designer do not have formname and do not get loaded from here.. so fall through
                    if ($dyn.value(this.FormName)) {
                        if ($dyn.serverForm.compilation.StaticLoader.staticLoaderOn) {
                            var interactionHandler_2 = $dyn.serverForm.interactionHandler;
                            $dyn.serverForm.compilation.StaticLoader.load($dyn.value(this.FormName), element, element.getAttribute("data-dyn-formid"), interactionHandler_2);
                        }
                        else {
                            serverCommand([]);
                        }
                    }
                };
            },
        };
        $dyn.serverForm.serializers.ShouldCreatePartForm = {
            deserialize: function (command, controlParams) {
                return function shouldCreatePartForm(options) {
                    // Check if this part is loaded inline. If so, we do not need to call create from the client
                    var shouldCreate = true;
                    var part = this;
                    var partForm = options.partForm;
                    if ($dyn.value(part.LoadInline)) {
                        var subscriberId_1 = null;
                        var checkCacheForFormDescriptors = function () {
                            // Get Part Form interactions from Cache
                            var partFormInteractions = $dyn.serverForm.cachedPartFormInteractions[part._serverId];
                            if (partFormInteractions) {
                                // Unsubscribe to part form cache updates
                                $dyn.serverForm.partFormCacheUpdated.unsubscribe(subscriberId_1);
                                $dyn.async(function () {
                                    $dyn.serverForm.registerForm({
                                        menuItem: $dyn.value(part.ObjectName),
                                        targetElement: options.element,
                                    });
                                    $dyn.serverForm.cachedPartFormInteractions[part._serverId] = null; // Clean up cache
                                    var partFormElement = $('[data-dyn-role="PartForm"]', part.element)[0];
                                    // create a changeIdInteraction
                                    var rootId = partFormInteractions[0].RootId;
                                    var clientId = partFormElement.getAttribute("data-dyn-clientid");
                                    var changeIdInteraction = [
                                        {
                                            $type: "ChangeViewModelIdInteraction",
                                            NewValue: rootId,
                                            PreviousValue: clientId,
                                            RootId: null,
                                            skipCache: true,
                                        },
                                    ];
                                    partFormInteractions = changeIdInteraction.concat(partFormInteractions);
                                    $dyn.serverForm.interactionHandler.processInteractions(partFormInteractions);
                                    partForm.PartFormCreated();
                                    $dyn.setValue(part, "LoadInline", false);
                                }, undefined, "Load inline PartForm descriptors.");
                            }
                        };
                        // Subscribe to part form cache updates
                        subscriberId_1 = $dyn.serverForm.partFormCacheUpdated.subscribe(checkCacheForFormDescriptors);
                        checkCacheForFormDescriptors();
                        shouldCreate = false;
                    }
                    // Check if this part is being reloaded as part of a popout
                    if (shouldCreate && $dyn.value(this.FormId)) {
                        // This partForm has been loaded before on a different window.
                        // Instead of creating the form again, we need to just send a Reserialize interaction for the form
                        var rootId = $dyn.value(this.FormId);
                        // Enqueue interaction to server (through interactionManger) to reload the form.
                        var commandInteraction = {
                            $type: $dyn.serverForm.InteractionType.command,
                            CommandName: "Reserialize",
                            TargetId: rootId,
                        };
                        var channelOptions = {
                            channelType: $dyn.serverForm.InteractionChannelType.byRootId,
                            rootId: rootId,
                        };
                        $dyn.serverForm.interactionManager.queueInteraction(commandInteraction, channelOptions, true);
                        shouldCreate = false;
                    }
                    return shouldCreate;
                };
            },
        };
        $dyn.serverForm.serializers.CreatePartForm = {
            deserialize: function (command, controlParams) {
                return function createForm(options) {
                    var part = this;
                    if (options.mode === "Local") {
                        var partForm_1 = options.partForm;
                        // If mode == Local
                        $dyn.async(function () {
                            $dyn.serverForm.registerForm({
                                menuItem: $dyn.value(part.ObjectName),
                                targetElement: options.element,
                            });
                            $dyn.callFunction(part.CreateForm, part, undefined, partForm_1.PartFormCreated.bind(partForm_1));
                        }, undefined, "Create part form local");
                    }
                    else if (options.mode === "Remote") {
                        // If mode == Remote
                        $dyn.async(function () {
                            $dyn.serverForm.getForm(options.resource);
                        }, undefined, "Create part form remote");
                    }
                };
            },
        };
        $dyn.serverForm.serializers.GetTileData = {
            deserialize: function (command, controlParams) {
                return function getTileData() {
                    if ($dyn.value(this.TileType) === $dyn.ui.TileType.kpi) {
                        var kpiName = $dyn.value(this.KpiName);
                        if (kpiName) {
                            var getKpiInteraction = {
                                $type: $dyn.serverForm.InteractionType.getTileKpiValuesInteraction,
                                CommandName: "GetTileKpiValuesInteraction",
                                ShouldBlockOnExecution: false,
                                TargetId: kpiName,
                            };
                            var channelOptions = {
                                channelType: $dyn.serverForm.InteractionChannelType.available,
                            };
                            $dyn.serverForm.interactionManager.queueCallbackCommandInteraction(getKpiInteraction, this.updateKpiFromJson, channelOptions, true);
                        }
                    }
                    else {
                        $dyn.logWarning("Tiles: GetTileData was called by a non-KPI tile.");
                    }
                };
            },
        };
        $dyn.serverForm.serializers.ChangeSelectedIndex = {
            // Custom command for grid selected index change to allow for different throttling options to be used.
            deserialize: function (command, controlParams) {
                var defaultCommand = $dyn.bindingFunctions.$command(controlParams, command);
                var executeImmediateCommandDescriptor = Object.create(command);
                executeImmediateCommandDescriptor.Properties = Object.create(command.Properties);
                executeImmediateCommandDescriptor.Properties.ThrottleValue = 0;
                executeImmediateCommandDescriptor.Properties.ExecuteImmediate = true;
                var executeImmediateCommand = $dyn.bindingFunctions.$command(controlParams, executeImmediateCommandDescriptor);
                return function changeSelectedIndex(args) {
                    var rowIndex = args[0];
                    var markMode = args[1];
                    var rangePivot = args[2];
                    var shouldThrottle = args[3];
                    var callback = args[4];
                    var completeCallback = args[5];
                    var skipRecording = args[6];
                    var beforeExecuteCallback = args[7];
                    var useCacheIndex = args[8];
                    var listContext = this;
                    var beforeExecuteCallbackInternal = function (commandInteraction) {
                        // Recalculate the row index used by the ChangeSelectedIndex command because
                        // the data start position may have changed
                        commandInteraction.PositionalParameters[0] = listContext.recalculateRowIndex(rowIndex);
                        if (beforeExecuteCallback) {
                            beforeExecuteCallback();
                        }
                    };
                    command.Properties.ShouldBlockOnExecution = false;
                    var commandArguments = [rowIndex, markMode, rangePivot];
                    if (skipRecording) {
                        commandArguments.push(true);
                    }
                    else if (useCacheIndex) {
                        commandArguments.push(false);
                    }
                    if (useCacheIndex) {
                        commandArguments.push(true);
                    }
                    var failureCallback = function () {
                        callback && callback(false);
                    };
                    if (shouldThrottle) {
                        $dyn.log.server && $dyn.log.server("ServerForm: Send throttled change row interaction to row index %s", rowIndex);
                        var throttleCallback = function () {
                            callback && callback(-1);
                        };
                        defaultCommand.call(this, commandArguments, callback, completeCallback, beforeExecuteCallbackInternal, throttleCallback, failureCallback);
                    }
                    else {
                        $dyn.log.server && $dyn.log.server("ServerForm: Send unthrottled change row interaction to row index %s", rowIndex);
                        executeImmediateCommand.call(this, commandArguments, callback, completeCallback, beforeExecuteCallbackInternal, null, failureCallback);
                    }
                };
            },
        };
        $dyn.serverForm.serializers.SelectCell = {
            // Custom command for grid selected index change to allow for different throttling options to be used.
            deserialize: function (command, controlParams) {
                var keyboardCommand = $dyn.bindingFunctions.$command(controlParams, command);
                // Mouse click expresses a direct intention to do a select and therefore do not need throttling.
                var mouseCommandDescriptor = Object.create(command);
                mouseCommandDescriptor.Properties = Object.create(command.Properties);
                mouseCommandDescriptor.Properties.ThrottleValue = 0;
                mouseCommandDescriptor.Properties.ExecuteImmediate = true;
                var mouseCommand = $dyn.bindingFunctions.$command(controlParams, mouseCommandDescriptor);
                return function selectCell(args) {
                    var rowIndex = args[0];
                    var selectedControl = args[1];
                    var inputMethod = args[2];
                    var evaluateAsTrackingId = args[3];
                    if (inputMethod === $dyn.ui.InputType.keyboard) {
                        keyboardCommand.call(this, [rowIndex, selectedControl, evaluateAsTrackingId]);
                    }
                    else {
                        mouseCommand.call(this, [rowIndex, selectedControl, evaluateAsTrackingId]);
                    }
                };
            },
        };
        $dyn.serverForm.serializers.PersistPersonalization = {
            // Custom logic for persist personalization command
            deserialize: function (command, controlParams) {
                var defaultCommand = $dyn.bindingFunctions.$command(controlParams, command);
                var rootId = $dyn.serverForm.interactionHandler.getRootIdByElement(controlParams._element);
                var channelOptions = {
                    channelType: $dyn.serverForm.InteractionChannelType.byRootId,
                    rootId: rootId,
                };
                return function persistPersonalization(args) {
                    $dyn.serverForm.interactionManager.removePendingPersonalization(controlParams._serverId, args[0], channelOptions);
                    defaultCommand.call(this, args);
                };
            },
        };
        $dyn.serverForm.serializers.ActionInteractionCommand = $dyn.serverForm.serializers.InteractionCommand;
    })(serverForm = $dyn.serverForm || ($dyn.serverForm = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Serializers.js.map
